// extracted by mini-css-extract-plugin
module.exports = {"home":"SaasOnly_home__2SGlt","section":"SaasOnly_section__3AZMj","oneSectionColumn":"SaasOnly_oneSectionColumn__MpCto","nonAdmin":"SaasOnly_nonAdmin__2xcN0"};